module.exports = __webpack_public_path__ + "media/site_templates/www.localhousepainters.com.au/images/feature_2-73a3481abeae43a4cd2cad5657d3f212.jpeg";